import { put, PutEffect, select, SelectEffect } from 'redux-saga/effects'
import addViewToStore from '../../../actions/views/addViewToStore'
import { ViewConstants } from '../../../actions/views/viewConstants'
import { getEntityDataViewState } from '../../../selectors/getters/entities/generic'

type Yield = SelectEffect | PutEffect
type Return = void
type Next = undefined | Record<string, any>

export function* ensureViewStateExists(
  viewConstant: ViewConstants
): Generator<Yield, Return, Next> {
  const view = yield select(getEntityDataViewState, viewConstant)

  if (view === undefined) {
    yield put(addViewToStore({ view: viewConstant }))
  }
}
